import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="resizeobserverentry" id="resizeobserverentry"></a>
    <h1 {...{
      "id": "windowresizeobserverentry"
    }}>{`window.ResizeObserverEntry`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry"
      }}>{`ResizeObserverEntry`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="new-resizeobserverentry-new" id="new-resizeobserverentry-new"></a>
    <h2 {...{
      "id": "resizeobserverentrytarget"
    }}>{`ResizeObserverEntry(target)`}</h2>
    <p>{`Represents the object passed to the ResizeObserver() constructor's callback function,
which allows access to the new dimensions of the Element.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Element`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The target element being observed.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="resizeobserverentry-target" id="resizeobserverentry-target"></a>
    <h2 {...{
      "id": "target--element"
    }}>{`target : `}<inlineCode parentName="h2">{`Element`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the target element being observed.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/target"
      }}>{`ResizeObserverEntry - target`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="resizeobserverentry-contentrect" id="resizeobserverentry-contentrect"></a>
    <h2 {...{
      "id": "contentrect--domrectreadonly"
    }}>{`contentRect : `}<inlineCode parentName="h2">{`DOMRectReadOnly`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the content rectangle of the target element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentRect"
      }}>{`ResizeObserverEntry - contentRect`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="resizeobserverentry-borderboxsize" id="resizeobserverentry-borderboxsize"></a>
    <h2 {...{
      "id": "borderboxsize--arrayresizeobserversize"
    }}>{`borderBoxSize : `}<inlineCode parentName="h2">{`Array<ResizeObserverSize>`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the border box size of the target element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/borderBoxSize"
      }}>{`ResizeObserverEntry - borderBoxSize`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="resizeobserverentry-contentboxsize" id="resizeobserverentry-contentboxsize"></a>
    <h2 {...{
      "id": "contentboxsize--arrayresizeobserversize"
    }}>{`contentBoxSize : `}<inlineCode parentName="h2">{`Array<ResizeObserverSize>`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Gets the content box size of the target element.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/contentBoxSize"
      }}>{`ResizeObserverEntry - contentBoxSize`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>
    <a name="resizeobserverentry-devicepixelcontentboxsize" id="resizeobserverentry-devicepixelcontentboxsize"></a>
    <h2 {...{
      "id": "devicepixelcontentboxsize--arrayresizeobserversize"
    }}>{`devicePixelContentBoxSize : `}<inlineCode parentName="h2">{`Array<ResizeObserverSize>`}</inlineCode></h2>
    <p><strong parentName="p">{`Read only`}</strong>{`
Throws an error because devicePixelContentBoxSize is not supported in UXP.`}</p>
    <p><strong parentName="p">{`Throws`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`DOMException`}</inlineCode>{` Always throws a NotSupportedError.`}</li>
    </ul>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserverEntry/devicePixelContentBoxSize"
      }}>{`ResizeObserverEntry - devicePixelContentBoxSize`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v8.1  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      